module.exports = __webpack_public_path__ + "static/media/google_it.bda6ecc9.jpeg";